import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class FaviconService {
    setFavicon(tenantId: string) {
        const favicon: HTMLLinkElement | null = document.querySelector('#dynamic-favicon');

        if (favicon) {
            favicon.href = `assets/favicon/${tenantId}.png`;
        }
    }
}